<template>
  <div
    class="phone-simulator">
    <div class="phone-number d-flex justify-content-center">
      <input type="text" class="form-control" v-model="phoneNumber" @focus="focusInput" @blur="blurInput" @keyup="reformatPhoneNumber"/>
    </div>
    <div class="keypad-container">
      <div class="keypad-number">
        <div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-around">
          <div class="">
            <button class="keypad" @click="keyPress(1)">1</button>
          </div>
          <div class="">
            <button class="keypad" @click="keyPress(2)">2</button>
          </div>
          <div class="">
            <button class="keypad" @click="keyPress(3)">3</button>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-around">
          <div class="">
            <button class="keypad" @click="keyPress(4)">4</button>
          </div>
          <div class="">
            <button class="keypad" @click="keyPress(5)">5</button>
          </div>
          <div class="">
            <button class="keypad" @click="keyPress(6)">6</button>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-around">
          <div class="">
            <button class="keypad" @click="keyPress(7)">7</button>
          </div>
          <div class="">
            <button class="keypad" @click="keyPress(8)">8</button>
          </div>
          <div class="">
            <button class="keypad" @click="keyPress(9)">9</button>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-around">
          <div class="">
            <button class="keypad" @click="keyPress('*')" >*</button>
          </div>
          <div class="">
            <button class="keypad" @click="keyPress(0)">0</button>
          </div>
          <div class="">
            <button class="keypad" @click="keyPress('#')">#</button>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-around">
          <div class="">
            <button class="keypad" @click="keyPress(8)" disabled>

            </button>
          </div>
          <div class="">
            <button class="keypad-call" @click="callAction()">
              <i class="fa fa-phone" aria-hidden="true"></i>
            </button>
          </div>
          <div class="">
            <button class="keypad-delete" @click="removeAction()">
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {CALL_TYPE} from '../../common/constant'
import ity from '../../lib/ity'
import Utils from '../../common/utils'

export default {
  name: 'Keypad',
  data () {
    return {
      phoneNumber: '',
      focus: false
    }
  },
  props: {
    call: {
      type: Function,
      required: true
    },
    audioInput: {
      type: String
    },
    audioOutput: {
      type: String
    },
  },
  created () {
    window.addEventListener('keydown', (e) => {
      if (ity.callType !== null) {
        return
      }
      if (e.key === 'Backspace') {
        this.removeAction()
      }
      if (e.key === 'Enter' && this.softphone.isOpenPopup) {
        this.callAction()
      }
      if (isNaN(e.key)) {
        return
      }
      this.keyPress(e.key)
    })
  },
  computed: {
    ...mapGetters([
      'softphone'
    ]),
  },
  mounted () {
    this.phoneNumber = this.softphone.phoneNumber
  },
  methods: {
    ...mapActions([
      'changePhoneNumber'
    ]),
    keyPress (number) {
      if (!this.focus) {
        this.phoneNumber += number
        this.changePhoneNumber({phoneNumber: this.phoneNumber})
      }
    },
    callAction () {
      // if (this.softphone.isOpenPopup) {
      //   this.call(true)
      //   ity.callType = CALL_TYPE.CALL_OUT
      // }
      if (this.phoneNumber.length === 0) {
        Utils.failedToast(this.$bvToast, 'Lỗi xảy ra', 'Chưa quay số')
        return
      }
      if (this.audioInput === null || this.audioOutput === undefined) {
        Utils.failedToast(this.$bvToast, 'Lỗi xảy ra', 'Chưa chọn thiết bị đầu vào, đầu ra')
        return
      }
      this.call(true)
      ity.callType = CALL_TYPE.CALL_OUT
    },
    removeAction () {
      if (!this.focus) {
        this.phoneNumber = this.phoneNumber.slice(0, -1)
        this.changePhoneNumber({phoneNumber: this.phoneNumber})
      }
    },
    focusInput () {
      this.focus = true
    },
    blurInput () {
      this.focus = false
      this.reformatPhoneNumber()
    },
    reformatPhoneNumber () {
      this.phoneNumber = this.phoneNumber.replace(/\/r/g, '/')
      this.changePhoneNumber({phoneNumber: this.phoneNumber})
    }
  },
}
</script>

<style scoped lang="scss">

.phone-simulator {
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;

  //border: 1px solid gray;

  .phone-number {
    input {
      background-color: transparent;
      border: none;
      text-align: center;
      font-size: 24px!important;
      font-weight: bold;
      &:focus{
        outline: none;
        border-color: inherit;
        -webkit-box-shadow: none;
        box-shadow: none;
      }
    }

    .delete-to-the-left {
      background-color: #e5e5e5;
      border: none;
      width: 40px;
      height: 30px;
    }
  }
}

.keypad-container {
  .keypad-number {
    padding: 20px;
  }

  .keypad {
    height: 70px;
    width: 70px;
    margin: 5px;
    border-radius: 33px;
    font-size: 24px;
    background-color: #e5e5e5;
    border: none;

    &:hover {
      background-color: #bbbbbb;
    }
  }

  .keypad-call {
    height: 70px;
    width: 70px;
    margin: 5px;
    border-radius: 33px;
    font-size: 24px;
    background-color: #1b86d3;
    border: none;
    color: white;
  }

  .keypad-delete {
    height: 70px;
    width: 70px;
    margin: 5px;
    border-radius: 33px;
    font-size: 24px;
    background-color: #e14858;
    border: none;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/telephone/Keypad.vue